module.exports = __webpack_public_path__ + "img/nl.1af2afbe.svg";